import WebApp from '@twa-dev/sdk';

export const showPopup = (...params: Parameters<(typeof WebApp)['showPopup']>) => {
  if (WebApp.platform === 'unknown') {
    const [{ title, message, buttons }] = params;

    const text = [title, message].filter(Boolean).join('\n');

    if (!buttons) {
      window.alert(text);
    } else {
      window.confirm(text);
    }

    return;
  }

  WebApp.showPopup(...params);
};
